import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { Layout, Typography, Button } from 'antd';

import AuthStorage from 'src/utils/AuthStorage';
import RightHeader from 'src/components/Layout/Header/RightHeader';

const { Header } = Layout;
const { Text } = Typography;

import styles from './styles';

//redux
import { getUserInfoId } from 'src/redux/actions/user';
import { withRouter } from 'next/router';
import Router from 'next/router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

function mapStateToProps(state) {
	return {
		store: {
			userId: state.user.userId
		}
	};
}
const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				getUserInfoId
			},
			dispatch
		)
	};
};

@injectSheet(styles)
@connect(
	mapStateToProps,
	mapDispatchToProps
)
class HeaderLayout extends Component {
	componentDidMount() {
		const { userId } = AuthStorage;
		if (userId) {
			this.getUserIdRquest(userId);
		}
	}

	getUserIdRquest = id => {
		this.props.action.getUserInfoId(
			{
				id
			},
			() => {
				this.setState({
					loading: false
				});
			},
			() => {
				this.setState({
					loading: false
				});
			}
		);
	};

	render() {

		const { isTama } = AuthStorage;
		const { router, classes, avatarMarginRight } = this.props;
		const {
			store: {
				userId: { data = {} }
			}
		} = this.props;

		const currentRoute = router.pathname;

		return (
			<Header className={classes.header}>
				<div style={{ marginLeft: '15px', display: 'inline-block' }}>
					<Text strong>{`'ia orana ${data.firstName || ''}`}</Text>
				</div>
				<div className={classes.right} style={{ marginRight: avatarMarginRight }}>
					{isTama && <>
						{currentRoute !== '/accounting' ?
							<Button href='/accounting' target='_blank' type="primary" icon="file-excel">
								Accès suivi comptable
							</Button>
							:
							<Button onClick={() => Router.pushRoute('/')} type="primary" icon="desktop">
								Retour back-office
							</Button>
						}
					</>}
					<RightHeader />
				</div>
			</Header>
		);
	}
}

export default withRouter(HeaderLayout);